import { createFileRoute, redirect } from '@tanstack/react-router'

// The section moved from Account › API to Account › Integrations. Every old link keeps working: the rest of the path,
// the search and the hash carry over (the `$` child below makes any depth match here).
export const Route = createFileRoute('/_app/account/api')({
  beforeLoad: ({ location }) => {
    const url = new URL(location.publicHref, 'http://x')
    // The bare section lands on the guide in one hop (Integrations has no overview); deeper paths map one to one.
    const pathname = /^\/account\/api\/?$/.test(url.pathname)
      ? '/account/integrations/guide'
      : url.pathname.replace(/^\/account\/api(?=\/|$)/, '/account/integrations')
    throw redirect({ href: pathname + url.search + url.hash, replace: true, statusCode: 301 })
  },
})
